import { useMedia } from 'react-use';

export const useIsMobile = () => {
  const is = useMedia('(max-width: 480px)');
  return is;
};
